<template>
    <div class="policy-version-stack">
        <ChildPrivacyPolicy20251124Content />
        <PersonalInfoPolicy20251124Content />
    </div>
</template>

<script>
import ChildPrivacyPolicy20251124Content from '@/views/policy/common/ChildPrivacyPolicy20251124Content.vue';
import PersonalInfoPolicy20251124Content from '@/views/policy/common/PersonalInfoPolicy20251124Content.vue';

export default {
    name: 'ChildPolicy20251124',
    components: {
        ChildPrivacyPolicy20251124Content,
        PersonalInfoPolicy20251124Content,
    },
};
</script>
